module.exports = __webpack_public_path__ + "static/media/LGP-192x192.434e4d95.png";